module.exports = __webpack_public_path__ + "static/media/Vamp4.1b4785cd.png";